import { render, staticRenderFns } from "./Bo.vue?vue&type=template&id=d6917144&"
import script from "./Bo.vue?vue&type=script&lang=ts&"
export * from "./Bo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports